// extracted by mini-css-extract-plugin
export var addressFields = "_p3-0";
export var animationContainer = "_p3-1";
export var footer = "_p3-2";
export var lineItems = "_p3-3";
export var modalContent = "_p3-4";
export var orderName = "_p3-5";
export var strong = "_p3-6";
export var warning = "_p3-7";